import { ExpandLess, ExpandMore } from '@mui/icons-material';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import MenuItem from 'app/shared/layout/menus/menu-item';
import React from 'react';
import { Translate } from 'react-jhipster';

interface IDrivers {
  isAdmin: boolean;
  isManufacturerAdmin: boolean;
  isTransporterAdmin: boolean;
  isRepresentativeAdmin: boolean;
  index: number;
  onExpand: (index: number) => void;
  isExpanded: boolean;
  setOpen: (value: boolean) => void;
  drawerIsOpen: boolean;
}

// REPRESENTATIVE_ADMIN sees only the scores: the assignment endpoints require ADMIN/MANUFACTURER_ADMIN/
// TRANSPORTER_ADMIN.
export const Drivers = ({
  isAdmin,
  isManufacturerAdmin,
  isTransporterAdmin,
  isRepresentativeAdmin,
  onExpand,
  isExpanded,
  index,
  drawerIsOpen,
  setOpen,
}: IDrivers) => {
  const initialTheme = localStorage.getItem('USER_THEME') as 'light' | 'dark' | null;

  return (
    <>
      <Tooltip title={drawerIsOpen ? '' : <Translate contentKey="global.menu.drivers">Motoristas</Translate>} placement="right">
        <ListItemButton
          id="drivers-button"
          onClick={() => onExpand(index)}
          sx={{
            pl: { xs: '18px', md: '32px' },
            backgroundImage: isExpanded
              ? initialTheme === 'dark'
                ? 'linear-gradient(rgba(6, 13, 31, 0.9), rgba(6, 13, 31, 0.9))'
                : 'linear-gradient(rgb(226,226,226), rgb(226,226,226))'
              : 'none',
          }}
        >
          <ListItemIcon>
            <AssignmentIndIcon />
          </ListItemIcon>
          <ListItemText
            primary={<Translate contentKey="global.menu.drivers">Motoristas</Translate>}
            primaryTypographyProps={{
              fontFamily: 'Public Sans',
              fontWeight: isExpanded ? '600' : '400',
              fontSize: '14px',
            }}
            sx={{ opacity: drawerIsOpen ? 1 : 0 }}
          />
          {isExpanded ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </Tooltip>

      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        {(isAdmin || isManufacturerAdmin || isTransporterAdmin || isRepresentativeAdmin) && (
          <List component="div" disablePadding onClick={() => setOpen(false)}>
            <MenuItem icon="caret-right" to="/driver-classification/dashboard">
              <Translate contentKey="fleetSenseApp.driverClassification.driverScore.title" />
            </MenuItem>
            {!isRepresentativeAdmin && (
              <MenuItem icon="caret-right" to="/driver-classification/assignment">
                <Translate contentKey="global.menu.driverAssignment" />
              </MenuItem>
            )}
          </List>
        )}
      </Collapse>
    </>
  );
};
